import { Component, OnInit, inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Observable } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';

import { BulkServicesService, ZonesService } from 'src/app/core/api/services';
import { EventTypes } from 'src/app/core/constants/event-types';
import { Validator } from 'src/app/core/constants/validators';
import { AppZone } from 'src/app/core/types/app-zone.type';
import { BaseFormModule } from 'src/app/pages/shared/base/modules/base-form.module';
import {
  CustomResultOfZoneDto,
  SimType,
  SmsAggregator,
  ZoneDto,
} from '../../../../core/api/models';
import { GenderType } from '../../../../core/api/models/gender-type';
import { NumberDto } from '../../../../core/api/models/number-dto';
import { RegularExpressions } from '../../../../core/constants/regular-expressions';
import { BaseFormPageComponent } from '../../../shared/base/components/base-form-page.component';
import { FormPageConfig } from './../../../../core/models/form-page-config.model';

@Component({
  selector: 'app-bulk-number-information-form',
  templateUrl: './bulk-number-information-form.component.html',
  imports: [BaseFormModule],
})
export class BulkNumberInformationFormComponent
  extends BaseFormPageComponent
  implements OnInit
{
  //#region Properties
  currentService = inject(BulkServicesService);
  zoneService = inject(ZonesService);

  formPageConfig: FormPageConfig<NumberDto> = {};

  //#region Enums
  get GenderType() {
    return GenderType;
  }
  get SmsAggregator() {
    return SmsAggregator;
  }
  get SimType() {
    return SimType;
  }

  //zones
  selectedState;
  selectedCountry = 1;
  selectedGuild = 1;
  //#endregion

  ngOnInit() {
    try {
      super.ngOnInit();
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.infrastructure
      );
    }
  }

  //#region init methods
  initForm() {
    this.form = new FormGroup({
      number: new FormControl('', [
        Validators.required,
        Validators.pattern(RegularExpressions.mobileNumberPrefixTo98),
        Validators.pattern(RegularExpressions.justNumber),
      ]),
      cityId: new FormControl('', Validators.required),
      stateId: new FormControl('', Validators.required),
      areaId: new FormControl('', Validators.required),
      genderType: new FormControl('', Validators.required),
      guildId: new FormControl(''),
      isBlackList: new FormControl(''),
      isBlackListLocal: new FormControl(''),
      mobileOperator: new FormControl('', Validators.required),
      simType: new FormControl('', Validators.required),
      subGuildId: new FormControl(''),
      zipCode: new FormControl('', Validator.zipCode),
    });
  }

  initModel(): void {
    this.model.genderType = GenderType.All;
  }
  //#region Api

  //#endregion

  // get zone by id
  getZoneById(zoneId: number): Observable<CustomResultOfZoneDto> {
    return this.zoneService.zonesGetZoneById({ Id: zoneId });
  }

  getSelectedState(cityId) {
    this.unSubs();

    //get city by zoneId
    this.getZoneById(cityId)
      .pipe(
        map((res) => res.data),
        map((city: ZoneDto) => {
          this.selectedState = city?.parentId;
          this.getSelectedCountry(this.selectedState);
          return city;
        }),
        takeUntil(this.onDestroy$)
      )
      .subscribe();
  }

  getSelectedCountry(stateId: number) {
    this.unSubs();

    //get city by zoneId
    this.getZoneById(stateId)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((state) => (this.selectedCountry = state.data.parentId));
  }

  onChangeZones(zoneId, zoneType: AppZone) {
    try {
      // this.model.areaId = 0;

      if (zoneType === 'states') {
        this.selectedCountry = zoneId;
        this.model.areaId = zoneId;
        this.selectedState = 0;
        this.model.stateId = -1;
      } else if (zoneType === 'cities') {
        this.selectedState = zoneId;
        this.model.stateId = zoneId;
        this.model.cityId = -1;
      }
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.infrastructure
      );
    }
  }

  convertMobile() {
    // this.model.mobile12 = Number(
    //   this.model.mobile12.toString().convertMobileNumberPrefixTo98().trim()
    // );
    // this.form.get('number').updateValueAndValidity();
  }
}
